module.exports = {
    LAYOUT_COLUMNS_LARGE: 1020,
    LAYOUT_COLUMNS_MEDIUM: 692,
};
